import React, { useMemo } from 'react'

import { PlusOutlined } from '@ant-design/icons'
import { Button } from 'antd'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { useOperatorData } from '@contexts/operator/OperatorDataContext'
import { useIsStandard } from '@contexts/operator/PlanContext'
import ListPageHeader from '@shared/ListPageHeader'
import SalesChannelsList from '@shared/sales_channels/SalesChannelsList'

import { salesChannelService } from '@services/operator/salesChannelService'

export default function OperatorSalesChannelsList() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { merchants } = useOperatorData()
  const isStandard = useIsStandard()

  const merchantOptions = useMemo(() => {
    return merchants.map(merchant => ({
      label: merchant.name,
      value: merchant.id
    }))
  }, [merchants])

  return (
    <div>
      <ListPageHeader
        items={[{ label: t('operator.menu.data.sales_channels') }]}
        actions={
          <Button type="primary" icon={<PlusOutlined />} onClick={() => navigate('/data/sales_channels/new')}>
            {t('common.button.new')}
          </Button>
        }
      />
      <SalesChannelsList
        service={salesChannelService}
        role="operator"
        merchantOptions={merchantOptions}
        hideMerchantUI={isStandard}
      />
    </div>
  )
}
